export default "__VITE_ASSET__$YW3AZ$T__"